import { wopi } from '@/plugins/axios'
import { lexonHttp } from '@/plugins/axios/lexonHttp'

export class DocumentOnlineService {
  constructor() {}

  getRequestToken(url: string, params: any) {
    return wopi.post(url, params)
  }
  getAppType(url: string, params: any) {
    return wopi.post(url, params)
  }
  getFileToken(url: string) {
    return lexonHttp.get(url)
  }
}
